export enum FraudFormOrigins {
  ONE = 'one',
  TWO = 'two',
  THREE = 'three',
  FOUR = 'four',
}
